import { Direction } from "../types";

// Currently we have only 2 calendar slides, and updating their content based on their week indexes
// We add + 2 (or -2 in case of going back, but will demonstrate with +2 from here) to them in 2 rounds:
//      - we add + 2 to the slide which slides in, on the beginning of the slide motion
//      - we add + 2 to the slide which slid out, only when the sliding motion ended, to prevent visual issues (already updated values on the slide which slid out)
// This function is handling the 1st, 2nd, 51st and 52nd week also, since we don't want to add 2 (or substract in the case of the 1st and 2nd week) to them
// If the current week which we want to update is 51 => set it's index to 1, instead of 53,
// Similarly handling this type of problem with week 1, 2 and 52

const handleWeekChange = (week: number, direction: Direction) => {
    if (direction === Direction.NEXT) {
        if (week === 51) {
            return 1;
        }
        if (week === 52) {
            return 2;
        }
        return week + 2;
    }

    if (direction === Direction.PREV) {
        if (week === 1) {
            return 51;
        }
        if (week === 2) {
            return 52;
        }
        return week - 2;
    }
    return 0;
};

export default handleWeekChange;
